<div [hidden]="isLoading" [attr.data-automation]="'helpdesk-line-button-features'">
  @for (field of fieldGroups.textInputs; track field) {
    <ziro-text [fieldId]="field"></ziro-text>
  }
  @for (fieldId of fieldGroups.ringInputs; track fieldId) {
    <ziro-select [fieldId]="fieldId"></ziro-select>
  }
  @for (field of fieldGroups.numberInputs; track field) {
    <ziro-text [fieldId]="field"></ziro-text>
  }
  @for (fieldId of fieldGroups.callRecordingInputs; track fieldId) {
    <ziro-select [fieldId]="fieldId"></ziro-select>
  }
  <ziro-select fieldId="monitoringCssName"></ziro-select>
</div>
